/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
  CmpTypographyField,
  CmpTextField,
  CmpSelectBoxMulti,
} from "../../Component/Common/ToolBox/ToolBox";
import { confirmAlert } from "react-confirm-alert";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  Set_SliceWmsPhysicalStockCount_SummaryObj,
  Set_SliceWmsPhysicalStockCount_HeadObj,
} from "./SliceWmsPhysicalStockCount";
import {
  CountAndAllArr,
  CountArr,
  Summary_Grid_Columns,
  get_Attribute,
} from "./WmsPhysicalStockCountAction";
import moment from "moment";
import {
  fAlertToast,
  GetGitterColumns,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import WmsPhysicalStockCount_BreadCrumbs from "./WmsPhysicalStockCount_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CmpTextFieldEnter } from "./../../Component/Common/ToolBox/ToolBox";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import { WmsPhysicalStockCountSummaryTblCard } from "./processComponent/WmsPhysicalStockCountSummaryTblCard";
import GCSAssignBinModal from "./processComponent/GCSAssignBinModal";
import GCNew from "./processComponent/GCNew";
import {
  PhysicalStockCount_AssignBinLoad,
  PhysicalStockCount_Assign_Approve,
  PhysicalStockCount_Assign_Delete,
  PhysicalStockCount_Assign_Reverse,
  PhysicalStockCount_Assign_Save,
  PhysicalStockCount_New_Approve,
  PhysicalStockCount_New_Attribute,
  PhysicalStockCount_New_Delete,
  PhysicalStockCount_New_Reverse,
  PhysicalStockCount_New_Save, 
  physicalstock_Attributes_GETROW,
} from "../../Server/ApiV2";
import MultiCheckboxComponent from "./processComponent/GCMultiSelect";
import { vRdxUserInfo } from "../../Redux/roStore";
import GCLgAutocomplete from "../../Component/Common/ReuseableComponent/GCLgAutocomplete";

export default function WmsPhysicalStockCount() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const [sAttribute, setAttribute] = useState({
    Location: [],
  });

  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  const [sSummaryObj, setSummaryObj] = useState({
    loc:
      !!sAttribute?.Location && sAttribute?.Location.length > 0
        ? sAttribute?.Location[0]?.UID
        : "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    DocNo: "",
    Count: "All",
  });
  let newObjInit = {
    A_SheetId: 0,
    A_Loc:
      !!sAttribute?.Location && sAttribute?.Location.length > 0
        ? sAttribute?.Location[0]?.UID
        : "",
    LocName: "",
    A_Date: new Date(),
    A_Status: "ENTER",
    A_RefNo: "",
    A_Count_Type: CountAndAllArr[0].UID,
    A_PDT_User: "",
    A_PDT_User_Name: "",
    A_Created_Status: "ENTER",
    BinAssignedStatus: "ENTER",
  };
  const [sNewObj, setNewObj] = useState({
    // SheetNo: 0,
    // Loc: sAttribute?.Location[0]?.UID,
    // LocName: "",
    // Date: new Date(),
    // ReferenceNo: "",
    // A_DocStat: "ENTER",
    A_SheetId: 0,
    A_Loc:
      !!sAttribute?.Location && sAttribute?.Location.length > 0
        ? sAttribute?.Location[0]?.UID
        : "",
    LocName: "",
    A_Date: new Date(),
    A_Status: "ENTER",
    A_RefNo: "",
    A_Count_Type: CountAndAllArr[0].UID,
    A_PDT_User: "",
    A_PDT_User_Name: "",
    A_Created_Status: "ENTER",
    BinAssignedStatus: "ENTER",
  });
  const [sErrorMsgNew, setErrorMsgNew] = useState({
    A_SheetId: "",
    A_Loc: "",
    LocName: "",
    A_Date: "",
    A_Status: " ",
    A_RefNo: "",
    A_Count_Type: "",
    A_PDT_User: "",
    A_PDT_User_Name: "",
    A_Created_Status: "",
    BinAssignedStatus: "",
  });
  const [sErrorMsgDetail, setErrorMsgDetail] = useState({
    SheetNo: "",
    Loc: "",
    LocName: "",
    Date: "",
    ReferenceNo: "",
    Count: "",
    User: "",
  });
  // modal start
  const [showModal, setShowModal] = useState(false);
  // modal end

  // modal start
  const [showNewModal, setShowNewModal] = useState(false);
  // modal end
  // modal start
  const [showAssignBinModal, setShowAssignBinModal] = useState(false);
  // modal end
  const [sAssignAttribute, setAssignAttribute] = useState({});
  const [sAssignBinObj, setAssignBinObj] = useState({
    SheetNo: 0,
    Loc:
      !!sAttribute?.Location && sAttribute?.Location.length > 0
        ? sAttribute?.Location[0]?.UID
        : "",
    Count: "",
    Asile: "",
    Level: [],
    LevelCSV: "",
    Status: "ENTER",
  });
  const [sErrorMsgAssignAssign, setErrorMsg] = useState({
    SheetNo: "",
    Loc: "",
    Count: "",
    Asile: "",
    Level: "",
  });

  const handleAutocompleteChange = (event, newValue) => {
    console.log(newValue);
    let currentPrnt = newValue.map((option) => option.UId).join(",");
    setAssignBinObj((obj) => ({
      ...obj,
      Level: newValue,
      LevelCSV: currentPrnt,
    }));
  };

  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fNew_OnChange = (e) => {
    setNewObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fAssignBin_OnChange = (e) => {
    setAssignBinObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoad = async (e) => {
    // dispatch(
    //   Set_SliceWmsPhysicalStockCount_SummaryObj({
    //     sSummaryObj,
    //   })
    // );

    await Get_Load_Grid_Data();
  };
  const Get_Load_Grid_Data = async (xA_Loc = sSummaryObj?.loc) => {
    var vSummaryObj = {
      loc: sSummaryObj.loc === "" ? xA_Loc : sSummaryObj?.loc,
      date1: moment(sSummaryObj?.dateFrom).format("MM/DD/YYYY"),
      date2: moment(sSummaryObj?.dateTo).format("MM/DD/YYYY"),
      usercd: vRdxuserInfo.UserID,
      sheetId: sSummaryObj.DocNo,
      CountType: sSummaryObj.Count,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vSummaryObj);
    const vItemSearch = await fExecuteAPI("WMIPT01_summary_GETROW", FinalObj);
    if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearch?.ResultSet?.length > 0) {
        const itemRows = vItemSearch?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_Date: moment(obj.A_Date).format("DD/MM/YYYY"),
        }));
        setSummaryGridRow(itemRows);
        setShowModal(false);
      } else {
        setSummaryGridRow([]);
      }
    } else {
      fAlertToast("FAILED", vItemSearch?.Message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const fRowCLick = (item) => {
    dispatch(
      Set_SliceWmsPhysicalStockCount_HeadObj({
        SheetNo: item.row.A_SheetId,
        Loc: item.row.A_Loc,
        LocName: item.row.LocName,
        Date: item.row.A_Date,
        ReferenceNo: item.row.A_RefNo,
        A_DocStat: item.row.A_Status,
        User: item.row.A_PDT_User,
        UserName: item.row.A_PDT_User_Name,
        Count: item.row.A_Count_Type,
        A_Created_Status: item.row.A_Created_Status,
        BinAssignedStatus: item.row.BinAssignedStatus,
        A_Status: item.row.A_Status,
      })
    );
    // navigate("/WmsPhysicalStockDetail");
  };
  const [sNewAttribute, setNewAttribute] = useState({
    User: [],
  });

  const fOpenNewModal = async () => {
    let iResp = await PhysicalStockCount_New_Attribute({
      SheetNo: "",
    });

    if (iResp.status == 200) {
      setNewAttribute(iResp.data.ResultSet);
      setShowNewModal(true);
      return iResp.data.ResultSet;
    }
  };

  const fNew = async () => {
    setNewObj(newObjInit);
    let iResp = await fOpenNewModal();
    setNewObj((obj) => ({
      ...obj,
      A_PDT_User: iResp?.User[0].UId,
    }));

    // dispatch(
    //   Set_SliceWmsPhysicalStockCount_HeadObj({
    //     SheetNo: 0,
    //     Loc: sAttribute?.Location[0]?.UID,
    //     LocName: "",
    //     Date: new Date(),
    //     ReferenceNo: "",
    //     A_DocStat: "ENTER",
    //   })
    // );
    // navigate("/WmsPhysicalStockDetail");
  };
  const fAssignBin = async (item) => {
    let iResp = await physicalstock_Attributes_GETROW({
      SheetID: item?.row?.A_SheetId || "",
      LocCd: item?.row?.A_Loc || "",
    });

    if (iResp.status == 200) {
      setAssignAttribute(iResp.data.ResultSet);
      let RespLevelArr =
        iResp?.data?.ResultSet?.AsileAndLevel[0]?.C_Lvl?.split(",") || [];
      console.log("RespLevelArr", RespLevelArr);
      console.log(
        "RespLevelArr1",
        iResp.data.ResultSet.Level.filter((obj) =>
          RespLevelArr.includes(obj.UId)
        )
      );

      setAssignBinObj((obj) => ({
        ...obj,
        SheetNo: item.row.A_SheetId,
        Loc: item.row.A_Loc,
        Count: item.row.A_Count_Type,
        LevelCSV: iResp?.data?.ResultSet?.AsileAndLevel[0]?.C_Lvl || "All",
        Asile:
          iResp?.data?.ResultSet?.AsileAndLevel?.length > 0
            ? iResp?.data?.ResultSet?.AsileAndLevel[0]?.C_Aisle
            : iResp.data.ResultSet?.Asile[0]?.UId,
        Status:
          iResp?.data?.ResultSet?.AsileAndLevel?.length > 0
            ? iResp?.data?.ResultSet?.AsileAndLevel[0]?.C_Status
            : "ENTER",

        Level:
          iResp?.data?.ResultSet?.AsileAndLevel?.length > 0
            ? iResp.data.ResultSet.Level.filter((obj) =>
                RespLevelArr.includes(obj.UId)
              )
            : iResp.data.ResultSet?.Level.filter((obj) => {
                return obj.UId == "All";
              }),
      }));
      await fAssignBinLoad(
        item.row.A_SheetId,
        iResp?.data?.ResultSet?.AsileAndLevel?.length > 0
          ? iResp?.data?.ResultSet?.AsileAndLevel[0]?.C_Aisle
          : iResp.data.ResultSet?.Asile[0]?.UId,
        iResp?.data?.ResultSet?.AsileAndLevel?.length > 0
          ? iResp?.data?.ResultSet?.AsileAndLevel[0]?.C_Lvl || "All"
          : iResp.data.ResultSet?.Level[0]?.UId
      );
      setShowAssignBinModal(true);
    }

    // dispatch(
    //   Set_SliceWmsPhysicalStockCount_HeadObj({
    //     SheetNo: item.row.A_SheetId,
    //     Loc: item.row.A_Loc,
    //     LocName: item.row.LocName,
    //     Date: item.row.A_Date,
    //     ReferenceNo: item.row.A_RefNo,
    //     A_DocStat: item.row.A_Status,
    //     User: item.row.A_PDT_User,
    //     UserName: item.row.A_PDT_User_Name,
    //     Count: item.row.A_Count_Type,
    //   })
    // );
  };
  const fAssignBinLoad = async (xSheetID, xAisle, xLvlCsv) => {
    let iResp = await PhysicalStockCount_AssignBinLoad({
      SheetID: xSheetID || "",
      Aisle: xAisle || "",
      LvlCsv: xLvlCsv || "",
    });

    if (iResp.status == 200 && iResp.data.ResultSet.length > 0) {
      const itemRows = iResp.data.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
        // L_Chk: "N",
      }));
      setGridrows(itemRows);
    } else {
      setGridrows([]);
    }
  };
  const [sGridrows, setGridrows] = useState([
    // {
    //   id: 1,
    //   binCode: "11",
    //   binName: "123",
    //   level: 1,
    //   A_PDT_User_Name: 1,
    //   L_Chk: "Y",
    // },
    // {
    //   id: 2,
    //   binCode: "12",
    //   binName: "5763",
    //   level: 1,
    //   A_PDT_User_Name: 1,
    //   L_Chk: "N",
    // },
  ]);
  const [sSummaryGridColumn2, setSummaryGridColumn2] =
    useState(Summary_Grid_Columns);

  const fSave = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    let APIObj = {
      v_A_SheetId: sNewObj.A_SheetId || 0,
      v_A_Loc: sNewObj.A_Loc || "",
      v_A_Date: moment(sNewObj.A_Date).format("MM/DD/YYYY") || "",
      v_A_Status: sNewObj.A_Status || "ENTER",
      v_A_RefNo: sNewObj.A_RefNo || "",
      v_UserCd: sNewObj.A_PDT_User,
      v_IP: vRdxUserInfoObj.IP,
      v_A_Count_Type: sNewObj.A_Count_Type || "",
      v_A_PDT_User: sNewObj.A_PDT_User || "",
    };
    let undefinedEntry = [
      { name: "Sheet Id", value: sNewObj.A_SheetId },
      { name: "Location", value: sNewObj.A_Loc },
      { name: "Reference No", value: sNewObj.A_RefNo },
      { name: "Date", value: sNewObj.A_Date },
      { name: "Status", value: sNewObj.A_Status },
      { name: "Count", value: sNewObj.A_Count_Type },
      { name: "User", value: sNewObj.A_PDT_User },
    ].find(
      (param) =>
        param.value === undefined || param.value === null || param.value === ""
    );

    if (undefinedEntry) {
      // If an undefined value is found, log the key name and mark it as empty
      fAlertToast("FAILED", `${undefinedEntry.name} is empty`);
      return;
    } else {
      let iResp = await PhysicalStockCount_New_Save(APIObj);

      if (iResp.status == 200) {
        console.log(iResp);
        setNewObj((obj) => ({
          ...obj,
          A_SheetId: iResp.data.ResultSet[0].SheetId,
        }));

        // SheetId
        fAlertToast("SUCCESS", "Saved Successfully ");
        fLoad();
        // setShowNewModal(false);
      }
    }
  };
  // useEffect(() => {
  //   GetGitterColumns(setSummaryGridColumn2, "PHYSTK", Summary_Grid_Columns);
  // }, []);

  const fSaveAssignBin = async (xSave = true) => {
    const filteredBinCodeObjects = sGridrows
      .filter((row) => row.L_Chk === "Y")
      .map((row) => ({ binCode: row.binCode }));

    console.log(filteredBinCodeObjects);

    let undefinedEntry = [
      { name: "Sheet Id", value: sAssignBinObj.SheetNo },
      { name: "Aisle", value: sAssignBinObj.Asile },
      { name: "Level ", value: sAssignBinObj?.LevelCSV },
    ].find(
      (param) =>
        param.value === undefined || param.value === null || param.value === ""
    );

    if (undefinedEntry) {
      // If an undefined value is found, log the key name and mark it as empty
      fAlertToast("FAILED", `${undefinedEntry.name} is empty`);
      return;
    }
    if (filteredBinCodeObjects.length == 0) {
      // If an undefined value is found, log the key name and mark it as empty
      fAlertToast("FAILED", `Select atleast one line item `);
      return;
    }
    let iResp = await PhysicalStockCount_Assign_Save({
      SheetID: sAssignBinObj.SheetNo || "",
      Aisle: sAssignBinObj.Asile || "",
      LvlCsv: sAssignBinObj?.LevelCSV || "",
      BinCd: filteredBinCodeObjects || [],
    });
    if (iResp.status == 200 && xSave) {
      // const itemRows = iResp.data.ResultSet?.map((obj, i) => ({
      //   ...obj,
      //   id: i + 1,
      //   // L_Chk: "N",
      // }));
      // setGridrows(itemRows);
      fAlertToast("SUCCESS", "Saved Successfully ");
      fLoad();
      // setShowAssignBinModal(false);
    } else if (iResp.status == 200) {
      let iResp = await PhysicalStockCount_Assign_Approve({
        SheetID: sAssignBinObj.SheetNo || "",
      });

      if (iResp.status == 200) {
        fLoad();
        fAlertToast("SUCCESS", "Approved Successfully ");
        setAssignBinObj((obj) => ({
          ...obj,
          Status: "POST",
        }));
        // setShowAssignBinModal(false);
      }
    }
  };
  const onLoad = async () => {
    let resp = await get_Attribute(setAttribute);
    let Loc =
      !!resp?.Location && resp?.Location.length > 0 ? resp?.Location[0]?.UID : "";
    setAssignAttribute((obj) => ({
      ...obj,
      Loc: Loc,
    }));
    setSummaryObj((obj) => ({
      ...obj,
      loc: Loc,
    }));
    setNewObj((obj) => ({
      ...obj,
      A_Loc: Loc,
    }));
    await Get_Load_Grid_Data(Loc);
  };
  useEffect(() => {
    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    LocationFocusOnLoad.current?.focus();
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        <WmsPhysicalStockCount_BreadCrumbs />

        <Box className="d-flex">
          <CmpButton
            xbtnName="Filter"
            xOnClick={() => {
              setShowModal(true);
            }}
            xVariant="contained"
            xSize="small"
          />
          &nbsp;
          <CmpButton
            xbtnName="New"
            xOnClick={fNew}
            xVariant="contained"
            xSize="small"
          />
        </Box>
      </div>
      <div className="">
        <>
          <WmsPhysicalStockCountSummaryTblCard
            data={sSummaryGridRow}
            onClick={(item) => {
              fRowCLick(item);
              // setNewObj(item.row)
              fOpenNewModal();
              setNewObj((obj) => ({
                ...obj,
                A_SheetId: item.row.A_SheetId,
                A_Loc: item.row.A_Loc,
                LocName: item.row.LocName,
                A_Date: item.row.A_Date,
                A_Status: item.row.A_Status,
                A_RefNo: item.row.A_RefNo,
                A_Count_Type: item.row.A_Count_Type,
                A_PDT_User: item.row.A_PDT_User,
                A_PDT_User_Name: item.row.A_PDT_User_Name,
                A_Created_Status: item.row.A_Created_Status,
                BinAssignedStatus: item.row.BinAssignedStatus,
              }));
            }}
            AssignBin={fAssignBin}
          />
        </>
      </div>
      <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter Modal"
        component={
          <>
            <Grid
              container
              spacing={{ xs: 2, sm: 2, md: 2 }}
              className="align-items-center"
              columns={{ xs: 12, sm: 12, md: 8 }}
            >
              <Grid item lg={2} md={4} xs={12}>
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  xLabelText="Location"
                  xValue={sSummaryObj.loc}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"loc"}
                  xData={sAttribute?.Location}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={sSummaryObj.dateFrom}
                  xOnChange={(newValue) => {
                    setSummaryObj((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }));
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={sSummaryObj.dateTo}
                  xOnChange={(newValue) =>
                    setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid
                item
                lg={2}
                md={4}
                xs={12}
                className="bintransfer-data-date"
              >
                <CmpTextFieldEnter
                  xLabelText={"Sheet.No"}
                  xVariant={"outlined"}
                  xValue={sSummaryObj.DocNo}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xReadOnly={false}
                  xType={"text"}
                  xName={"DocNo"}
                  xOnKeyUp={(e) => {
                    if (e.key === "Enter") {
                      fLoad();
                    }
                  }}
                  xOnEnter={(e) => {
                    if (e.key === "Enter") {
                      fLoad();
                    }
                  }}
                  xSmShow={!!vMediaQuery}
                />
              </Grid>
              <Grid
                item
                lg={2}
                md={4}
                xs={12}
                className="bintransfer-data-date"
              >
                <CmpSelectBox
                  xLabelText="Count"
                  xValue={sSummaryObj.Count}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"Count"}
                  xData={CountArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid
                item
                lg={2}
                md={4}
                xs={12}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={fLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </>
        }
      />

      <GCNew
        xOpen={showNewModal}
        fCloseModal={() => {
          setShowNewModal(false);
        }}
        xTitle={`${sNewObj.A_SheetId!==0?'SheetDetails':'Create Newsheet'}`}
        component={
          <>
            <Grid
              container
              spacing={{ xs: 2, sm: 2, md: 3 }}
              className="align-items-center"
              columns={{ xs: 12, sm: 12, md: 12 }}
            padding={"10px"}
              
            >
              <Grid item xs={3} sm={2} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Sheet No"} />
              </Grid>
              <Grid item xs={9} sm={10} md={10}>
                <CmpTextField
                  xTextAlign="center"
                  xtabIndex={"1"}
                  xValue={sNewObj.A_SheetId}
                  xVariant={"standard"}
                  xType={"text"} // text/number/password
                  xName={"A_SheetId"}
                  xReadOnly={true}
                  xOnChange={fNew_OnChange}
                  xError={sErrorMsgNew.A_SheetId === "" ? false : true}
                  xErrorMessage={sErrorMsgNew.A_SheetId}
                />
              </Grid>
              <Grid item xs={3} sm={2} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Ref.No"} />
              </Grid>
              <Grid item xs={9} sm={10} md={10}>
                <CmpTextField
                  xtabIndex={"3"}
                  xValue={sNewObj.A_RefNo}
                  xType={"text"} // text/number/password
                  xName={"A_RefNo"}
                  xReadOnly={false}
                  xOnChange={fNew_OnChange}
                  xOnKeyUp={() => {}}
                  xError={sErrorMsgNew.A_RefNo === "" ? false : true}
                  xErrorMessage={sErrorMsgNew.A_RefNo}
                  xTextAlign="center"
                />
              </Grid>
              {/* <Grid item xs={3} sm={2} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Location"} />
              </Grid> */}
              <Grid item xs={12} sm={6} md={6} >
                <CmpSelectBox
                  xtabIndex={"2"}
                  xLabelText="Location"
                  xValue={sNewObj.A_Loc}
                  xOnChange={fNew_OnChange}
                  xName={"A_Loc"}
                  xData={sAttribute?.Location}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsgNew.A_Loc === "" ? false : true}
                  xErrorMessage={sErrorMsgNew.A_Loc}
                  xDisable={false}
                 
                />
              </Grid>

              {/* <Grid item xs={3} sm={2} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Date"} />
              </Grid> */}
              <Grid item xs={12} sm={6} md={6}>
                <CmpDatePicker
                  xDisable={false}
                  xtabIndex={"4"}
                  xLabelText={"A_Date"}
                  xValue={sNewObj.A_Date}
                  xOnChange={(event) => {
                    if (
                      event?.$d == "Invalid Date" ||
                      event?.$d == null ||
                      event?.$d === undefined ||
                      event?.$d === ""
                    ) {
                      setNewObj((obj) => ({
                        ...obj,
                        A_Date: "",
                      }));
                    } else {
                      setNewObj((obj) => ({
                        ...obj,
                        A_Date: event?.$d,
                      }));
                    }
                  }}
                  xName={"A_Date"}
                  xError={sErrorMsgNew.A_Date === "" ? false : true}
                  xErrorMessage={sErrorMsgNew.A_Date}
                  xFullWidth={true}
                />
                {/* <CmpDatePickerField
                xtabIndex={"4"}
                xValue={sNewObj.Date}
                xOnChange={fDate}
                xName={"Date"}
                xError={xErrorMsg.Date === "" ? false : true}
                xErrorMessage={xErrorMsg.Date}
              /> */}
              </Grid>
              {/* <Grid item xs={3} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Count"} />
              </Grid> */}
              <Grid item xs={12} sm={6} md={6}>
                <CmpSelectBox
                  xLabelText="A_Count_Type"
                  xValue={sNewObj.A_Count_Type}
                  xOnChange={fNew_OnChange}
                  xName={"A_Count_Type"}
                  xData={CountAndAllArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsgNew.A_Count_Type === "" ? false : true}
                  xErrorMessage={sErrorMsgNew.A_Count_Type}
                  xDisable={false}
                />
              </Grid>
              {/* <Grid item xs={3} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"User"} />
              </Grid> */}
              <Grid item xs={12} sm={6} md={6} >
                <CmpSelectBox
                  xLabelText="A_PDT_User"
                  xValue={sNewObj.A_PDT_User}
                  xOnChange={fNew_OnChange}
                  xName={"A_PDT_User"}
                  xData={sNewAttribute.User}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsgNew.A_PDT_User === "" ? false : true}
                  xErrorMessage={sErrorMsgNew.A_PDT_User}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={4} sm={2.4} md={2.4} className="text-center"  >
                <CmpButton
                  xbtnName="New"
                  xOnClick={(e) => {
                    if (sNewObj.A_SheetId > 0) {
                      setNewObj(newObjInit);
                      setNewObj((obj) => ({
                        ...obj,
                        A_SheetId: sNewObj.A_SheetId,
                        A_PDT_User: sNewAttribute?.User[0]?.UId,
                      }));
                    } else {
                      setNewObj(newObjInit);
                      setNewObj((obj) => ({
                        ...obj,
                        A_PDT_User: sNewAttribute?.User[0]?.UId,
                      }));
                    }
                  }}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
              <Grid item xs={4} sm={2.4} md={2.4} className="text-center" >
                <CmpButton
                  xbtnName="Save"
                  xOnClick={async (e) => {
                    fSave();
                  }}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={sNewObj.A_Created_Status != "ENTER"}
                />
              </Grid>
              <Grid item xs={4} sm={2.4} md={2.4} className="text-center"  >
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={async (e) => {
                    confirmAlert({
                      title: "Delete",
                      message: "Are you want to  Delete.",
                      buttons: [
                        {
                          className: "alertBtn",
                          name: "DeletYes",
                          label: "Yes",
                          onClick: async () => {
                            const vRdxUserInfoObj = vRdxUserInfo();

                            let iResp = await PhysicalStockCount_New_Delete({
                              v_A_SheetId: sNewObj.A_SheetId || 0,
                              v_UserCd: vRdxUserInfoObj.UserID,
                              v_IP: vRdxUserInfoObj.IP,
                            });

                            if (iResp.status == 200) {
                              fAlertToast("SUCCESS", "Deleted Successfully ");
                              setShowNewModal(false);
                              fLoad();
                            }
                          },
                        },
                        {
                          className: "alertBtn",
                          label: "No",
                          onClick: () => "",
                        },
                      ],
                    });
                  }}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={
                    sNewObj.A_Created_Status != "ENTER" ||
                    sNewObj.A_SheetId == 0
                  }
                />
              </Grid>
              {sNewObj.A_Created_Status == "POST" ? (
                <Grid item xs={6} sm={2.4} md={2.4} className="text-center" > 
                  <CmpButton
                    xbtnName="Reverse"
                    xOnClick={async (e) => {
                      confirmAlert({
                        title: "Reverse",
                        message: "Are you want to  Reverse.",
                        buttons: [
                          {
                            className: "alertBtn",
                            name: "DeletYes",
                            label: "Yes",
                            onClick: async () => {
                              let iResp = await PhysicalStockCount_New_Reverse({
                                SheetID: sNewObj.A_SheetId || 0,
                              });

                              if (iResp.status == 200) {
                                fAlertToast(
                                  "SUCCESS",
                                  "Reversed Successfully "
                                );
                                fLoad();
                                setNewObj((obj) => ({
                                  ...obj,
                                  A_Created_Status: "ENTER",
                                }));
                                // setShowNewModal(false);
                              }
                            },
                          },

                          {
                            className: "alertBtn",
                            label: "No",
                            onClick: () => "",
                          },
                        ],
                      });
                    }}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
              ) : (
                <Grid item xs={6} sm={2.4} md={2.4} className="text-center"  >
                  <CmpButton
                    xbtnName="Approve"
                    xOnClick={async (e) => {
                      confirmAlert({
                        title: "Approve",
                        message: "Are you want to  Approve.",
                        buttons: [
                          {
                            className: "alertBtn",
                            name: "DeletYes",
                            label: "Yes",
                            onClick: async () => {
                              const vRdxUserInfoObj = vRdxUserInfo();
                              let iResp = await PhysicalStockCount_New_Save({
                                v_A_SheetId: sNewObj.A_SheetId || 0,
                                v_A_Loc: sNewObj.A_Loc || "",
                                v_A_Date:
                                  moment(sNewObj.A_Date).format("MM/DD/YYYY") ||
                                  "",
                                v_A_Status: sNewObj.A_Status || "ENTER",
                                v_A_RefNo: sNewObj.A_RefNo || "",
                                v_UserCd: sNewObj.A_PDT_User,
                                v_IP: vRdxUserInfoObj.IP,
                                v_A_Count_Type: sNewObj.A_Count_Type || "",
                                v_A_PDT_User: sNewObj.A_PDT_User || "",
                              });

                              if (iResp.status == 200) {
                                let iResponce =
                                  await PhysicalStockCount_New_Approve({
                                    SheetID: sNewObj.A_SheetId || 0,
                                  });

                                if (iResponce.status == 200) {
                                  fAlertToast(
                                    "SUCCESS",
                                    "Approved Successfully "
                                  );
                                  setNewObj((obj) => ({
                                    ...obj,
                                    A_Created_Status: "POST",
                                  }));
                                  fLoad();
                                  // setShowNewModal(false);
                                }
                              }
                            },
                          },
                          {
                            className: "alertBtn",
                            label: "No",
                            onClick: () => "",
                          },
                        ],
                      });
                    }}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={
                      sNewObj.A_Created_Status != "ENTER" ||
                      sNewObj.A_SheetId == 0
                    }
                  />
                </Grid>
              )}

              <Grid item xs={6} sm={2.4} md={2.4} className="text-center" >
                <CmpButton
                  xbtnName="Print"
                  xOnClick={(e) => {}}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </>
        }
      />
      <GCSAssignBinModal
        xOpen={showAssignBinModal}
        fCloseModal={() => {
          setShowAssignBinModal(false);
        }}
        xTitle="Bin allocation modal"
        component={
          <>
            <Grid
              container
              spacing={{ xs: 2, sm: 2, md: 2 }}
              className="align-items-center"
              columns={{ xs: 12, sm: 12, md: 12 }}
              padding={"10px"}
            >
              <Grid item xs={3} sm={2} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Sheet No"} />
              </Grid>
              <Grid item xs={9} sm={10} md={10}>
                <CmpTextField
                  xTextAlign="center"
                  xtabIndex={"1"}
                  xValue={sAssignBinObj.SheetNo}
                  xVariant={"standard"}
                  xType={"text"} // text/number/password
                  xName={"SheetNo"}
                  xReadOnly={true}
                  xOnChange={fAssignBin_OnChange}
                  xError={sErrorMsgAssignAssign.SheetNo === "" ? false : true}
                  xErrorMessage={sErrorMsgAssignAssign.SheetNo}
                />
              </Grid>

              {/* <Grid item xs={3} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Location"} />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4}>
                <CmpSelectBox
                  xtabIndex={"2"}
                  xLabelText="Location"
                  xValue={sAssignBinObj.Loc}
                  xOnChange={fAssignBin_OnChange}
                  xName={"Loc"}
                  xData={sAttribute?.Location}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsgAssignAssign.Loc === "" ? false : true}
                  xErrorMessage={sErrorMsgAssignAssign.Loc}
                  xDisable={true}
                />
              </Grid>

              {/* <Grid item xs={3} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Count"} />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4}>
                <CmpSelectBox
                  xLabelText="Count"
                  xValue={sAssignBinObj.Count}
                  xOnChange={fAssignBin_OnChange}
                  xName={"Count"}
                  xData={CountAndAllArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsgAssignAssign.Count === "" ? false : true}
                  xErrorMessage={sErrorMsgAssignAssign.Count}
                  xDisable={true}
                />
              </Grid>
              {/* <Grid item xs={3} sm={2} md={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Asile"} />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4}>
                <CmpSelectBox
                  xLabelText="Asile"
                  xValue={sAssignBinObj.Asile}
                  xOnChange={fAssignBin_OnChange}
                  xName={"Asile"}
                  xData={sAssignAttribute.Asile}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsgAssignAssign.Asile === "" ? false : true}
                  xErrorMessage={sErrorMsgAssignAssign.Asile}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={1.8} sm={1} md={1}>
                <CmpTypographyField xcomponent={"span"} xText={"Level"} />
              </Grid>
              <Grid item xs={10.2} sm={9} md={9}>
                {/* <MultiCheckboxComponent
                  options={sAssignAttribute.Level}
                  handleChange={(event) => {
                    const { value } = event.target;
                    setAssignBinObj((obj) => ({
                      ...obj,
                      Level: value,
                    }));
                  }}
                  selectedValues={sAssignBinObj.Level}
                /> */}
                <GCLgAutocomplete
                  xtabIndex={"10"}
                  // xLabelText="Level"
                  xValue={sAssignBinObj.Level}
                  options={sAssignAttribute.Level}
                  handleChange={handleAutocompleteChange}
                />
              </Grid>

              <Grid item xs={12} sm={2} md={2} className="text-center">
                <CmpButton
                  xbtnName="Load"
                  xOnClick={async (e) => {
                    await fAssignBinLoad(
                      sAssignBinObj.SheetNo,
                      sAssignBinObj.Asile,
                      sAssignBinObj?.LevelCSV
                    );
                  }}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={sAssignBinObj.Status != "ENTER"}
                />
              </Grid>
            </Grid>
            <Box sx={{ height: "45vh", width: "100%",mt:"20px" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                      borderColor: 'primary.light',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
                }}
                rows={sGridrows}
                columns={sSummaryGridColumn2}
                hideFooter={sGridrows.length < 100}
                onRowClick={(e) => {}}
                // components={{
                //   Toolbar: vMediaQuery ? "" : GridToolbar,
                // }}
                // checkboxSelection={sAssignBinObj.Status != "ENTER"}
                checkboxSelection={sAssignBinObj.Status == "ENTER"}
                onSelectionModelChange={(params) => {
                  let modifiedSelect = sGridrows.map((el) => {
                    if (params.includes(el.id)) {
                      return { ...el, L_Chk: "Y" };
                    } else {
                      return { ...el, L_Chk: "N" };
                    }
                  });
                  // console.log("modifiedSelect", modifiedSelect);
                  setGridrows(modifiedSelect);
                }}
                selectionModel={sGridrows
                  ?.filter((row) => row?.L_Chk === "Y")
                  .map((row) => row?.id)}
              />
            </Box>
            <Grid
              container
              spacing={{ xs: 1, sm: 2, md: 2 }}
              className="align-items-center mt-1"
              columns={{ xs: 12, sm: 12, md: 12 }}
            >
              <Grid item xs={4} sm={4} md={4} className="text-center">
                <CmpButton
                  xbtnName="Save"
                  xOnClick={async (e) => {
                    // PhysicalStockCount_Assign_Save
                    await fSaveAssignBin(true);
                  }}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={sAssignBinObj.Status != "ENTER"}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4} className="text-center">
                <CmpButton
                  xbtnName="Release"
                  xOnClick={async (e) => {
                    // PhysicalStockCount_Assign_Save
                    confirmAlert({
                      title: "Delete",
                      message: "Are you want to  Release.",
                      buttons: [
                        {
                          className: "alertBtn",
                          name: "DeletYes",
                          label: "Yes",
                          onClick: async () => {
                            let iResp = await PhysicalStockCount_Assign_Delete({
                              SheetID: sAssignBinObj.SheetNo || "",
                            });

                            if (iResp.status == 200) {
                              fAlertToast("SUCCESS", "Deleted Successfully ");
                              fLoad();
                              setShowAssignBinModal(false);
                            }
                          },
                        },
                        {
                          className: "alertBtn",
                          label: "No",
                          onClick: () => "",
                        },
                      ],
                    });
                  }}
                  xVariant="contained"
                  xSize="small"
                  xDisabled={
                    sAssignBinObj.Status != "ENTER" ||
                    sAssignBinObj.SheetNo == 0
                  }
                />
              </Grid>
              {sAssignBinObj.Status == "POST" ? (
                <Grid item xs={4} sm={3} md={4} className="text-center">
                  <CmpButton
                    xbtnName="Reverse"
                    xOnClick={async (e) => {
                      confirmAlert({
                        title: "Reverse",
                        message: "Are you want to  Reverse.",
                        buttons: [
                          {
                            className: "alertBtn",
                            name: "DeletYes",
                            label: "Yes",
                            onClick: async () => {
                              let iResp =
                                await PhysicalStockCount_Assign_Reverse({
                                  SheetID: sAssignBinObj.SheetNo || "",
                                });

                              if (iResp.status == 200) {
                                fAlertToast(
                                  "SUCCESS",
                                  "Reversed Successfully "
                                );
                                fLoad();
                                setAssignBinObj((obj) => ({
                                  ...obj,
                                  Status: "ENTER",
                                }));
                                // setShowAssignBinModal(false);
                              }
                            },
                          },
                          {
                            className: "alertBtn",
                            label: "No",
                            onClick: () => "",
                          },
                        ],
                      });
                    }}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
              ) : (
                <Grid item xs={4} sm={3} md={3} className="text-center">
                  <CmpButton
                    xbtnName="Approve"
                    xOnClick={async (e) => {
                      confirmAlert({
                        title: "Approve",
                        message: "Are you want to  Approve.",
                        buttons: [
                          {
                            className: "alertBtn",
                            name: "DeletYes",
                            label: "Yes",
                            onClick: async () => {
                              await fSaveAssignBin(false);
                            },
                          },
                          {
                            className: "alertBtn",
                            label: "No",
                            onClick: () => "",
                          },
                        ],
                      });
                    }}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={sAssignBinObj.Status != "ENTER"}
                  />
                </Grid>
              )}
            </Grid>
          </>
        }
      />
    </div>
  );
}
